// extracted by mini-css-extract-plugin
export default {"caixona":"p3_caixona__H55iE","caixa":"p3_caixa__llk2Y"};